if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const items = [];
      var addons = document.querySelectorAll(".addon");
        addons.forEach(addon => {
          if (addon && addon.classList.contains("added")) {
            const productObject = {
              quantity: 1,
              id: parseInt(addon.dataset.id),
              // properties: {
              //   'Addon': 'true',
              //   'Parent Product': addon.dataset.parentTitle
              // }
            }
            const currentAddon = addon;
            if (currentAddon.dataset.vip) {
              productObject.selling_plan = 1176928428;
            }
            items.push(productObject);
        }});
        const data = {
          items: items
        }
        if(items && items.length){
        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
        .then(response => {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          function getSelectedQuantity() {
            const quantityForm = document.querySelector('.product-form__quantity');
            const numberInput = document.querySelector('.quantity__input');
            if (!quantityForm) {
              console.warn('Quantity form not found');
              return 1; // Default quantity
            }
            
            if(numberInput) {
              return parseInt(numberInput.value, 10) || 1;
            }
          }


          
          const quantity = getSelectedQuantity();

          
          const formData = new FormData(this.form);
          const hasCustomQuantity = formData.has('custom_quantity');
          formData.set('quantity', quantity); // Set the quantity in formData

          

          if (this.cart) {
            formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          // for (let [key, value] of formData.entries()) {
          //   console.log(key, value);
          // }
    
          fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            
            if (response.status) {
              this.handleErrorMessage(response.description);
  
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if(hasCustomQuantity){
                window.location = '/checkout';
                 return;
              } else {
                window.location = window.routes.cart_url;
                 return;
              }
            }
  
            if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      }

      else {        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

          function getSelectedQuantity() {
            const quantityForm = document.querySelector('.product-form__quantity');
            const numberInput = document.querySelector('.quantity__input');
            if (!quantityForm) {
              console.warn('Quantity form not found');
              return 1; // Default quantity
            }
            
            if(numberInput) {
              return parseInt(numberInput.value, 10) || 1;
            }
          }
          
        
        const quantity = getSelectedQuantity();

  
        const formData = new FormData(this.form);
        formData.set('quantity', quantity); // Set the quantity in formData
        const hasCustomQuantity = formData.has('custom_quantity');

        
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);


        }
          config.body = formData;
          
    
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
              if(hasCustomQuantity){
                window.location = '/checkout';
                return;
              } else {
                window.location = window.routes.cart_url;
                return;
              }
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
